import type { Product } from "@arena/shared";

export type ProductSort = "name-asc" | "name-desc" | "price-asc" | "price-desc" | "category";

export const productSortOptions: Array<{ value: ProductSort; label: string }> = [
  { value: "name-asc", label: "Nome: A–Z" },
  { value: "name-desc", label: "Nome: Z–A" },
  { value: "category", label: "Categoria" },
  { value: "price-asc", label: "Menor preço" },
  { value: "price-desc", label: "Maior preço" },
];

const collator = new Intl.Collator("pt-BR", { sensitivity: "base", numeric: true });

export function sortProducts(products: Product[], order: ProductSort): Product[] {
  return [...products].sort((left, right) => {
    if (order === "name-desc") return collator.compare(right.name, left.name);
    if (order === "price-asc") return left.priceCents - right.priceCents || collator.compare(left.name, right.name);
    if (order === "price-desc") return right.priceCents - left.priceCents || collator.compare(left.name, right.name);
    if (order === "category") {
      return collator.compare(left.categoryName ?? "Sem categoria", right.categoryName ?? "Sem categoria")
        || collator.compare(left.name, right.name);
    }
    return collator.compare(left.name, right.name);
  });
}
